function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_3402",
  "data-name": "Group 3402",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "21"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_941",
  "data-name": "Path 941",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_942",
  "data-name": "Path 942",
  d: "M19 3l4 5h-3v12h-2V8h-3zm-5 15v2H3v-2zm0-7v2H3v-2zm-2-7v2H3V4z",
  fill: "#fff"
})));